import { gql } from '@efficiently/client-core-graphql-models';

export const TAG_TO_CONTENT_FIELDS = gql(`
	fragment TagToContentFields on TagToContent {
		_id
		tagId
		contentId
		projectId
		folderId
	}
`);
